module.exports = __webpack_public_path__ + "static/media/sample_5-02.844b0910.jpg";